import { localOffset } from "@/dto/local.key.dto";
import { globals } from "@/main";
import { defineComponent, PropType } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "c-dynamic-tab",
  props: {
    textLoading: { type: String, default: "onboardProcessing" },
    isLoading: { type: Boolean, default: false },
    isTranslate: { type: Boolean, default: true },
    isDisabled: { type: Boolean, default: false },
    tabs: { type: Array as PropType<string[]>, default: () => [] },
    active: { type: String, default: "" },
  },
  emits: ["update:active"],

  setup(props, { emit }) {
    const route = useRoute();

    const setActiveTab = (tabValue: string) => {
      if (tabValue !== undefined && tabValue !== null) {
        localStorage.setItem(localOffset, String(0));
        globals.$helper.setStateFilter("");

        emit("update:active", tabValue);
      }
    };

    return {
      setActiveTab,
      route,
    };
  },
});
